import { useContext } from 'react';
import { ThemeContext } from '../contexts/theme-context';

/**
 * Hook to access and control the current theme
 *
 * @throws Error if used outside of ThemeProvider
 * @returns ThemeContext with theme state and control functions
 *
 * @example
 * ```tsx
 * const { theme, setTheme, toggleTheme } = useTheme();
 *
 * return (
 *   <button onClick={toggleTheme}>
 *     Current theme: {theme}
 *   </button>
 * );
 * ```
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
